import React from 'react';
import DefaultAvatar from '../assets/defaultAvatar.png';
import icon_mail from '../assets/icon_mail.png';
import icon_phone from '../assets/icon_phone.png'; 

const AccountCoursesTab = ({ courseDetails }) => {
    return (
        <div
            id="account_courses-list"
            style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)', // แบ่ง 2 คอลัมน์
                gap: '16px', // ระยะห่างระหว่างรายการ
                boxSizing: 'border-box',
            }}
        >
            {courseDetails?.account_courses?.length > 0 ? (
                courseDetails.account_courses.map((account_course) => (
                    <div
                        key={account_course.uid}
                        className="account_courses-item"
                        style={{
                            padding: '20px 10px',
                            textAlign: 'left',
                            display: 'flex',
                            alignItems: 'center',
                            border: '1px solid #dddddd',
                            borderRadius: '16px',
                            background: 'white',
                        }}
                    >
                        <div style={styles.Sectiontwo}>
                            <div style={styles.ImgArea}>
                                <img
                                    src={account_course.image_url ? account_course.image_url : DefaultAvatar}
                                    alt="Profile"
                                    style={styles.ImgProfile}
                                />
                            </div>
                            <div>
                                <p style={{ fontSize: '10px', color: 'black', margin: 0, fontWeight: 'bold' }}>
                                    {account_course.rank_position}
                                </p>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <p style={{ fontSize: '12px', color: '#44526e', fontWeight: 'bold', margin: 0 }}>
                                        {account_course.short_position}
                                    </p>
                                    <p style={{ fontSize: '12px', color: '#44526e', fontWeight: 'bold', margin: 0 }}>
                                        {account_course.first_name}
                                    </p>
                                    <p style={{ fontSize: '12px', color: '#44526e', fontWeight: 'bold', margin: 0 }}>
                                        {account_course.last_name}
                                    </p>
                                    <p style={{ fontSize: '12px', color: '#44526e', margin: 0 }}>
                                        ({account_course.nick_name})
                                    </p>
                                </div>
                                <div style={styles.textIcon}>
                                    <img src={icon_mail} alt="icon_mail" style={styles.imgIcon} />
                                    <p style={{ fontSize: '12px', color: '#595959', margin: 0 }}>
                                        {account_course.email}
                                    </p>
                                </div>
                                <div style={styles.textIcon}>
                                    <img src={icon_phone} alt="icon_phone" style={styles.imgIcon} />
                                    <p style={{ fontSize: '10px', color: '#595959', margin: 0 }}>
                                        {account_course.phone}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))
            ) : null}
        </div>
    );
};

const styles = {
    Sectiontwo:{
        display:'flex',
        textAlign:'left',
        alignItems: 'center',
        gap:'8px' ,
      },
      ImgProfile:{
        width: '100%',
         height: '100%',
         objectFit: 'cover'
     },
     ImgArea:{
        width: '65px', 
      height: '65px', 
      borderRadius: '50%', 
      overflow: 'hidden', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center'
      },
      imgIcon:{
        width:'6%'
      },
      textIcon:{
        display:'flex',
        alignItems:'center',
        gap:'8px'
      },
}

export default AccountCoursesTab;
